/**
 * RoutesPanel - Inventario de rutas del proyecto
 *
 * @version 3.0
 * @updated 2026-02-27
 * @module core/modules/waste/components/panels
 *
 * @description
 * Panel de inventario de rutas configurado con BaseInventoryPanel.
 * Todas las funcionalidades (paginación, sorting, multi-select, eye, zoom, etc.)
 * están implementadas en el componente base.
 *
 * @remarks
 * Migrado desde implementación custom (194 líneas) a configuración (5 líneas).
 * Ahora incluye todas las funcionalidades de TreesPanel:
 * - Paginación dinámica
 * - Sorting por todas las columnas
 * - Multi-selección (checkboxes + acciones masivas)
 * - Toggle visibilidad individual (eye button)
 * - Zoom a ruta en mapa
 * - Hover bidireccional tabla ↔ mapa
 * - Modos narrow/wide responsive
 */

import { BaseInventoryPanel } from '../../../../layouts/panels/LeftPanel';
import { routesInventoryConfig } from '../../config/routes-inventory.config';

/**
 * Panel de inventario de rutas.
 * Wrapper del BaseInventoryPanel configurado para rutas de recolección.
 */
export function RoutesPanel(): JSX.Element {
  return <BaseInventoryPanel config={routesInventoryConfig} />;
}
